import type {
  DateString,
  IsoDateAndTimeNoTimezoneString,
  TimeString,
} from '#/types/TypedDateString';

export function splitDateAndTimeNoTimezoneString(
  dateTimeString: IsoDateAndTimeNoTimezoneString,
): [DateString, TimeString] {
  return dateTimeString.split('T') as [DateString, TimeString];
}
